import format from 'date-fns/format';
import en from 'date-fns/locale/en-US';
import is from 'date-fns/locale/is';
import { getCurrentLangPretty } from '../url/urlHelpers';

export const formatCurrency = currency => {
	return currency.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

const getDateLocale = (locale: 'is' | 'en') => {
	return locale === 'is' ? is : en;
};

const getDateFormat = (locale: 'is' | 'en') => {
	return locale === 'is' ? 'd. LLLL yyyy' : 'LLLL d, yyyy';
};

export const formatDate = (dateString: string) => {
	if (!dateString) {
		return '';
	}
	const locale = getCurrentLangPretty();
	return format(new Date(dateString), getDateFormat(locale), {
		locale: getDateLocale(locale),
	});
};
